<template>
  <NotLogged
    formTitle="Weryfikacja dwuetapowa"
    :afterMessage="message"
  >
    <template #form>
      <form @submit.prevent="confirm" class="pb-6" autocomplete="off">
        <input
          v-focus
          v-model="form.value"
          type="text"
          :maxlength="useRecovery ? null : 6"
          :placeholder="useRecovery ? 'kod odzyskiwania' : 'kod z aplikacji'"
          :disabled="isBusy"
          required
        >

        <button
          type="button"
          class="text-sm text-blue-600 mt-1 underline focus:outline-none"
          :disabled="isBusy"
          @click="toggleMode"
        >
          {{ useRecovery
          ? 'Mam dostęp do aplikacji – użyj kodu z aplikacji'
          : 'Nie mam dostępu do aplikacji – użyj kodu odzyskiwania'
          }}
        </button>

        <button
          type="submit"
          class="btn btn-primary w-full rounded-sm mt-3"
          :disabled="isBusy"
        >
          <span v-if="!isBusy">Potwierdź</span>
          <span v-else>Weryfikacja...</span>
        </button>
      </form>
    </template>
  </NotLogged>
</template>

<script>
import NotLogged from '../components/NotLogged.vue';
import TwoFactorService from '../services/TwoFactorService';

export default {
  name: 'TwoFactorLogin',
  components: {
    NotLogged,
  },
  data() {
    return {
      form: {
        value: '',
      },
      useRecovery: false,
      isBusy: false,
      message: '',
    };
  },
  computed: {
    key() {
      return this.$route.query.key;
    },
  },
  mounted() {
    if (!this.key) {
      this.$router.replace({ name: 'login' });
    }
  },
  methods: {
    toggleMode() {
      this.useRecovery = !this.useRecovery;
      this.form.value = '';
      this.message = '';
    },
    confirm() {
      this.message = '';

      if (!this.useRecovery && this.form.value.length !== 6) {
        this.message = 'Nieprawidłowy kod';
        return;
      }

      if (this.useRecovery && !this.form.value) {
        this.message = 'Kod odzyskiwania jest wymagany';
        return;
      }

      this.isBusy = true;

      const payload = {
        key: this.key,
        ...(this.useRecovery
          ? { recovery_code: this.form.value }
          : { code: this.form.value }),
      };

      TwoFactorService.challenge(payload)
        .then(response => {
          this.$store.commit('SET_USER_DATA', response.data.result);

          if (this.$store.getters.backToURL) {
            this.$router.push(this.$store.getters.backToURL);
            this.$store.dispatch('clearBackToURL');
          } else {
            this.$router.push({ name: 'orders' });
          }
        })
        .catch(() => {
          this.message = 'Nieprawidłowy kod lub sesja wygasła';
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
  },
};
</script>

<style scoped>
input {
  @apply bg-white;
  @apply border;
  @apply rounded-sm;
  @apply py-2;
  @apply px-4;
  @apply block;
  @apply w-full;
  @apply appearance-none;
  @apply leading-normal;
  @apply text-2xl;
  @apply my-2;
}
input:focus {
  @apply outline-none;
  @apply border-blue-300;
}
</style>
